import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { parseBoardView, type ParsedBoardView } from '../boardView'

/**
 * The Build board's view + epic filter, parsed from the URL (INV-R.4). Read
 * only: every write is a `<Link to={{ search: boardViewSearch(…) }}>`, so a
 * toggle or filter change pushes one history entry and Back restores it.
 */
export function useBoardView(): ParsedBoardView {
  const [params] = useSearchParams()
  return useMemo(() => parseBoardView(params), [params])
}
